import React, { Component } from "react";
import {
  withStyles,
  Drawer,
  Typography,
  TextField,
  Button,
  AppBar,
  Toolbar,
  Grid,
} from "@material-ui/core";
import FileUpload from "../AddNew/FileUpload";

const drawerWidth = 500;

const styles = (theme) => ({
  root: {
    width: drawerWidth,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "100%",
  },
  textStyle: {
    fontWeight: 400,
  },
  paddingForm: {
    padding: "20px",
  },
  formControl: {
    minWidth: "100%",
    paddingLeft: 10,
  },
});

class DbtResearchProjectAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      equipment_name: "",
      sanctioned_cost: "",
      actual_cost: "",
      quantity_procured: "",
      date_of_purchase: "",
      upload_info: [],
      loadFile: true,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  componentDidMount() {
    if (this.props.edit) {
      this.setState({
        ...this.props.edit_data,
        upload_info: this.props.edit_data.upload_info || [],
      });
    } else {
      this.setState({
        id: "",
        equipment_name: "",
        sanctioned_cost: "",
        actual_cost: "",
        quantity_procured: "",
        date_of_purchase: "",
        upload_info: [],
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.edit) {
        this.setState({
          ...this.props.edit_data,
          upload_info: this.props.edit_data.upload_info || [],
        });
      } else {
        this.setState({
          id: "",
          equipment_name: "",
          sanctioned_cost: "",
          actual_cost: "",
          quantity_procured: "",
          date_of_purchase: "",
          upload_info: [],
        });
      }
    }
  }

  onSubmit(e) {
    e.preventDefault();

    let {
      id,
      equipment_name,
      sanctioned_cost,
      actual_cost,
      quantity_procured,
      date_of_purchase,
      upload_info,
    } = this.state;

    const data = {
      id,
      equipment_name,
      sanctioned_cost,
      actual_cost,
      quantity_procured,
      date_of_purchase,
      upload_info,
    };

    if (this.props.edit) {
      this.props.esetData(data);
    } else {
      this.props.setData(data);
    }

    this.setState({
      id: "",
      equipment_name: "",
      sanctioned_cost: "",
      actual_cost: "",
      quantity_procured: "",
      date_of_purchase: "",
      upload_info: [],
    });
  }

  onDeleteClick(id) {
    this.props.onDeleteClick(id);
  }

  render() {
    let { classes } = this.props;

    return (
      <div>
        <Drawer
          className={classes.root}
          anchor="right"
          open={this.props.show}
          onClose={this.props.handleClose}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <AppBar
            position="static"
            color={this.props.edit ? "secondary" : "primary"}
          >
            <Toolbar>
              <Typography variant="h6" color="inherit">
                {this.props.edit
                  ? "Edit DBT Research Project"
                  : "Add DBT Research Project"}
              </Typography>
            </Toolbar>
          </AppBar>

          <div className={classes.paddingForm}>
            <form onSubmit={this.onSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12}>
                  <TextField
                    label="Name of the Equipment or Asset"
                    name="equipment_name"
                    className={classes.textField}
                    type="text"
                    margin="normal"
                    required
                    variant="outlined"
                    InputLabelProps={{
                      classes: {
                        root: classes.textStyle,
                      },
                    }}
                    value={this.state.equipment_name}
                    onChange={this.onChange}
                  />
                </Grid>

                <Grid item xs={12} lg={12}>
                  <TextField
                    label="Sanctioned Cost"
                    name="sanctioned_cost"
                    className={classes.textField}
                    type="text"
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      classes: {
                        root: classes.textStyle,
                      },
                    }}
                    value={this.state.sanctioned_cost}
                    onChange={this.onChange}
                  />
                </Grid>

                <Grid item xs={12} lg={12}>
                  <TextField
                    label="Actual Cost"
                    name="actual_cost"
                    className={classes.textField}
                    type="text"
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      classes: {
                        root: classes.textStyle,
                      },
                    }}
                    value={this.state.actual_cost}
                    onChange={this.onChange}
                  />
                </Grid>

                <Grid item xs={12} lg={12}>
                  <TextField
                    label="Quantity Procured"
                    name="quantity_procured"
                    className={classes.textField}
                    type="text"
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      classes: {
                        root: classes.textStyle,
                      },
                    }}
                    value={this.state.quantity_procured}
                    onChange={this.onChange}
                  />
                </Grid>

                <Grid item xs={12} lg={12}>
                  <TextField
                    label="Date of Purchase"
                    name="date_of_purchase"
                    className={classes.textField}
                    type="date"
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                      classes: {
                        root: classes.textStyle,
                      },
                    }}
                    value={this.state.date_of_purchase}
                    onChange={this.onChange}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <label>Upload Photo</label>
                  {this.state.loadFile ? (
                    <FileUpload
                      dp={this.state.upload_info}
                      type={`DBT_RESEARCH_PROJECT`}
                      setDp={this.handleChange.bind(this, "upload_info")}
                    />
                  ) : null}
                </Grid>
              </Grid>
              <br />
              <div>
                <Button
                  type="submit"
                  variant="contained"
                  color={this.props.edit ? "secondary" : "primary"}
                  className={classes.button}
                >
                  {this.props.edit ? "Update" : "Submit"}
                </Button>

                {this.props.edit ? (
                  <span>
                    &nbsp;
                    <Button
                      type="button"
                      variant="contained"
                      color="secondary"
                      className={classes.button}
                      onClick={this.onDeleteClick.bind(
                        this,
                        this.props.edit_data.id
                      )}
                    >
                      Delete
                    </Button>
                  </span>
                ) : null}
              </div>
            </form>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default withStyles(styles)(DbtResearchProjectAdd);
